import I18n from 'I18n';
import { useMemo } from 'react';
// Mock data that differentiates between qa/prod environments
function getMockUmbrellaCollections() {
  return [{
    slug: 'ai-essentials',
    title: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.title'),
    description: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.description'),
    htmlPageTitle: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.htmlPageTitle'),
    metaDescription: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.metaDescription'),
    collectionIds: [],
    collectionSlugs: ['hubspot-connectors', 'partner-connectors']
  }];
}
export function useUmbrellaCollections() {
  const mockData = useMemo(() => {
    return {
      collections: getMockUmbrellaCollections()
    };
  }, []);

  // For now, we return the mock data
  // Later this can be replaced with a DFC query
  return {
    data: mockData,
    loading: false,
    error: undefined,
    getUmbrellaCollectionBySlug: slug => {
      return mockData.collections.find(collection => collection.slug === slug);
    }
  };
}